import {
  Component,
  Input,
  OnInit,
  OnChanges,
  Output,
  EventEmitter,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { CommonPropertyDetailConstant } from '../common-property-detail-page.constant';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { CommonPropertyDetailMenuEnum } from '../common-property-detail-page.enum';
import { takeUntil, Subject, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ContactSalesComponent } from 'src/app/common/components/contact-sales/contact-sales.component';

@Component({
  selector: 'app-office-rental-details-table',
  templateUrl: './office-rental-details-table.component.html',
  styleUrls: ['./office-rental-details-table.component.scss']
})
export class OfficeRentalDetailsTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() property_uid: string = '';
  
  @Output() isEmpatyCheck = new EventEmitter();

  overViewMenu = CommonPropertyDetailConstant.overViewMenu;
  tableColumns: any[] = CommonPropertyDetailConstant.officeColumns;
  tableData: any[] = [];
  showLoader: boolean = false;
  current_lang: string = 'en';

  private destroy$ = new Subject<void>();
  private languageSub$: Subscription = new Subscription();

  constructor(
    private sharedService: SharedService,
    private reportService: ReportService,
    private propertyService: CommonPropertyDetailPageService,
    private matDialog: MatDialog
  ) {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.current_lang = lang;
      if (this.property_uid) {
        this.fetchData();
      }
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes:SimpleChanges): void {
   if (changes['property_uid']?.currentValue) {
      this.fetchData();
    }
  }

  fetchData(): void {
    this.showLoader = true;
    this.propertyService
      .getPropertyRental(20, 0, '', this.property_uid, 'office')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          if (res.status === 200) {
            // convert range strings to number if needed
            res.data.forEach((el: any) => {
              Object.keys(el).forEach((key: any) => {
                if (key !== 'unit_size') {
                  el[key] = this.reportService.rangeToNumberFor(el[key]);
                }
              });
            });
            this.tableData = this.reportService.setTableDataSource(res.data);
            this.isEmpatyCheck.emit(false);
          } else {
            this.tableData = [];
           this.isEmpatyCheck.emit(true);
          }
        },
        error: () => {
          this.showLoader = false;
          this.tableData = [];
          this.isEmpatyCheck.emit(true);
        }
      });
  }

  openContactSales() {
    this.matDialog.open(ContactSalesComponent, {
      width: '600px',
      maxHeight: '95vh',
      panelClass: 'contact-form',
      data: { Type: 'contact_us' }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.languageSub$.unsubscribe();
  }
}
